(() => {
  const header = document.querySelector('[data-cigno-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 30);
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobile = document.querySelector('[data-mobile-menu]');
  const toggleMenu = (force) => {
    if(!mobile) return;
    const open = typeof force === 'boolean' ? force : !mobile.classList.contains('is-open');
    mobile.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
    menuBtn?.setAttribute('aria-expanded', String(open));
  };
  menuBtn?.addEventListener('click', () => toggleMenu());
  mobile?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => toggleMenu(false)));

  const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
    if(entry.isIntersecting){entry.target.classList.add('is-visible'); reveal.unobserve(entry.target);}
  }), {threshold:.12});
  document.querySelectorAll('[data-reveal]').forEach(el => reveal.observe(el));

  const modal = document.querySelector('[data-watch-modal]');
  const setText = (sel, value) => { const el = modal?.querySelector(sel); if(el) el.textContent = value || ''; };
  const closeModal = () => { if(!modal) return; modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.body.classList.remove('no-scroll'); };
  document.querySelectorAll('[data-watch-open]').forEach(card => card.addEventListener('click', () => {
    if(!modal) return;
    const d = card.dataset;
    const img = modal.querySelector('[data-modal-image]');
    if(img){img.src=d.image || ''; img.alt=d.name || 'CIGNO watch';}
    setText('[data-modal-name]', d.name); setText('[data-modal-family]', d.family); setText('[data-modal-description]', d.description);
    setText('[data-modal-case]', d.case); setText('[data-modal-dial]', d.dial); setText('[data-modal-movement]', d.movement); setText('[data-modal-note]', d.note);
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.classList.add('no-scroll');
    modal.querySelector('[data-modal-close]')?.focus();
  }));
  modal?.querySelector('[data-modal-close]')?.addEventListener('click', closeModal);
  modal?.addEventListener('click', e => { if(e.target === modal) closeModal(); });
  document.addEventListener('keydown', e => { if(e.key === 'Escape'){closeModal(); toggleMenu(false);} });
})();
